<template>
  <section v-if="events.length !== 0 || locations.length !== 0" class="container-fluid exp-mt" :aria-label="ariaLabel">
    <div v-if="featuredEventsTitle || featuredEventsDescription" class="mt-5 mx-5">
      <h2 class="">{{ featuredEventsTitle }}</h2>
      <div v-html="featuredEventsDescription" class="featured-events-description"></div>
    </div>
    <EventsLocationsCarousel :featuredEventsLocations="events.concat(locations)"
      :featuredEventsLocationsMinusFirstOne="featuredMinusOne" />
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import EventsLocationsCarousel from '@/components/Experiences/Common/EventsLocationsCarousel.vue';

@Component({
  data() {
    return {
      events: [],
      locations: [],
      featuredMinusOne: null,
    };
  },
  props: {
    experience: {
      type: String,
      required: true,
    },
  },
  async created() {
    await this.getEvents();
    await this.getLocations();
    await this.featuredEventsLocationsMinusFirstOne();
  },
  components: {
    EventsLocationsCarousel,
  },
  methods: {
    async getEvents() {
      if (!this.$store.state.events.featured || this.$store.state.events.featured.length === 0) {
        await this.$store.dispatch('events/getFeaturedEvents');
      }
      this.events = this.$store.state.events.featured.sort((a, b) => a.startDate - b.startDate);

      // Filter out events by experience type
      this.events = this.events.filter(event => event.experienceTypes.includes(Number(this.experience)) || event.experienceTypes.value === (Number(this.experience)));
    },
    async getLocations() {
      if (!this.$store.state.locations.featured || this.$store.state.locations.featured.length === 0) {
        await this.$store.dispatch('locations/getFeaturedLocations');
      }
      this.locations = this.$store.state.locations.featured;

      // Filter out locations by experience type and that have images
      this.locations = this.locations.filter(loc => loc.imageUrl !== null).filter(loc => loc.experienceTypes.includes(Number(this.experience)));
    },
    featuredEventsLocationsMinusFirstOne() {
      const featuredEventsLocations = this.events.concat(this.locations);
      this.featuredMinusOne = featuredEventsLocations.slice(1, featuredEventsLocations.length);
    },
  },
})
class ExperienceFeaturedEvents extends Vue {
  @Prop({
    type: [Array],
    required: true,
  })
  featuredEvents;

  @Prop({ type: String })
  featuredEventsTitle;

  @Prop({ type: String })
  featuredEventsDescription;

  @Prop({
    type: String,
    required: true,
  })
  ariaLabel;
}

export default ExperienceFeaturedEvents;
</script>

<style lang="scss" scoped>
.featured-events-description {
  display: flex;
  margin: 0 auto;
  max-width: 620px;
  font-family: 'IdealSans-Book';
  font-size: 16px;
  font-weight: 325;
  line-height: 19px;
  letter-spacing: 0em;
}

.exp-mt {
  margin-top: 120px;
}
</style>
